import { render, staticRenderFns } from "./automationRuleList.vue?vue&type=template&id=99a7888c&"
import script from "./automationRuleList.vue?vue&type=script&lang=js&"
export * from "./automationRuleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports